export enum TimelineIconType {
  Grey = 'grey',
  Warn = 'warn',
  None = 'none'
}
